<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-4">
        <vue-drag-tree
          :data="treeModel"
          :allowDrag="allowDrag"
          :allowDrop="allowDrop"
          :defaultText="'New Node'"
          :displayCheckBox="displayCheckBox"
          :createNodeFlag="true"
          :deleteNodeFlag="false"
          :isCreateLevel="true"
          :createLevel="lockLevel"
          :isFieldCreateFlag="true"
          :fieldCreateFlag="`is_control_product`"
          :negativity="true"
          :isNotCreateStatus="true"
          :statusNotCreate="statusNotCreate"
          @current-node-clicked="curNodeClicked"
          @drag="dragHandler"
          @drag-enter="dragEnterHandler"
          @drag-leave="dragLeaveHandler"
          @drag-over="dragOverHandler"
          @drag-end="dragEndHandler"
          @drop="dropHandler"
          @createNode="onCreateNode"
          @deleteNode="onDeleteNode"
        >
        </vue-drag-tree>
      </div>
      <div class="col-lg-8" v-if="isShowData">
        <div class="card">
          <div class="card-body" v-if="isEdit">
            <InventoryCategoryDetailEditor
              ref="detailEditor"
              :isChanged.sync="isPayloadChanged"
              v-model="input"
            />
            <div class="row">
              <div class="col-md-6">
                <div class="text-left">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="onBack()"
                    >
                      <i
                        class="bx bx-arrow-back font-size-16 align-middle mr-2"
                      ></i>
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="text-right">
                  <div class="button-items">
                    <button
                      v-if="isPayloadChanged"
                      type="button"
                      class="btn btn-send-approve"
                      @click="onSubmit"
                    >
                      <i class="bx bx-user-check" />Save or Send to Approve
                    </button>
                    <button
                      type="reset"
                      class="btn btn-light"
                      @click="onConfirmReset"
                    >
                      <i class="bx bx-reset" />Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    v-show="isShowEditBtn"
                    @click="onEdit()"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Inventory
                  </button>
                </div>
              </div>
            </div>
            <b-form-group
              label="Root"
              label-for="input_root"
              label-cols-sm="3"
              v-if="input.level !== 1"
            >
              <label class="col-form-label col-sm-7">{{ input.root }}</label>
            </b-form-group>
            <b-form-group
              label="ประเภท"
              label-for="type"
              label-cols-sm="3"
              v-if="input.level !== 1"
            >
              <label class="col-form-label col-sm-7">{{ input.type }}</label>
            </b-form-group>
            <b-form-group
              label="รหัส (OFM)"
              label-for="input_code"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">{{ input.code }}</label>
            </b-form-group>
            <b-form-group
              label="ชื่อ (ไทย)"
              label-for="input_displayname_th"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">{{
                input.display_name.th
              }}</label>
            </b-form-group>
            <b-form-group
              label="ชื่อ (อังกฤษ)"
              label-for="input_displayname_en"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">{{
                input.display_name.en
              }}</label>
            </b-form-group>
            <b-form-group
              label="ประเภท"
              label-for="type"
              label-cols-sm="3"
              v-if="input.level === 1"
            >
              <label class="col-form-label col-sm-7">
                <label :class="`label label-${typeLabel}`">
                  {{ input.type }}
                </label>
              </label>
            </b-form-group>
            <b-form-group
              label="Product Line"
              label-for="input_product_line"
              label-cols-sm="3"
              v-if="input.level === 2"
            >
              <label class="col-form-label col-sm-7">{{
                input.product_line
              }}</label>
            </b-form-group>
            <b-form-group
              label="GP Stabdrad (%)"
              label-for="input_gp_standard"
              label-cols-sm="3"
              v-if="input.level === 2"
            >
              <label class="col-form-label col-sm-7">{{
                input.gp_standard
              }}</label>
            </b-form-group>
            <b-form-group
              label="สำหรับสินค้าฟรี"
              label-for="input_is_free"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">
                <label class="label label-yes" v-if="input.is_free">Yes</label>
                <label class="label label-no" v-else>No</label>
              </label>
            </b-form-group>
            <b-form-group
              label="สถานะ"
              label-for="input_status"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">
                <label :class="`label label-${statusLabel}`">
                  {{ input.status }}
                </label>
              </label>
            </b-form-group>
            <b-form-group
              label="สำหรับจัดการสินค้า"
              label-for="input_is_control_product"
              label-cols-sm="3"
            >
              <label class="col-form-label col-sm-7">
                <label class="label label-yes" v-if="input.is_control_product"
                  >Yes</label
                >
                <label class="label label-no" v-else>No</label>
              </label>
            </b-form-group>
            <div class="form-group row mb-4" v-if="input.is_control_product">
              <label class="col-form-label col-sm-3">Hybrid Category</label>
              <div class="col-sm-9">
                <div class="row">
                  <div class="col-sm-12">
                    <template
                      v-for="(item, index) in input.mappingHybridCategoryItems"
                    >
                      <b-alert show variant="secondary" v-bind:key="index"
                        ><b>{{ index + 1 }}</b
                        >) {{ genHybridDisplay(item) }}</b-alert
                      >
                    </template>
                    <!-- <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="mappingHybridCategorytable"
                        :empty-text="'ไม่พบข้อมูล'"
                        :show-empty="mappingHybridCategoryItems.length == 0"
                        :bordered="true"
                        :items="mappingHybridCategoryItems"
                        align="center"
                        v-bind:fields="fieldsDetail"
                        :perPage="perPage"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (firstRowOnPage + data.index) | number }}
                          </div>
                        </template>
                      </b-table>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="button-items" style="float: left">
              <button type="button" class="btn btn-light" @click="onBack()">
                <i class="bx bx-arrow-back" />Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-create-view
      :activeModal="modal.createView"
      :parent_id="parent_id"
      :level="level"
      :root="root"
      :type="type"
      :is_free="is_free"
      @hidden="modal.createView = false"
      @createView="createView"
    ></modal-create-view>
  </div>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import VueDragTree from '@/libs/vue-drag-tree/src/VueDragTree'

import PageHeader from '@/components/page-header'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import inventoryCategoryService from '@/helpers/service/inventory-category-service'
import modalCreateView from '@/components/view-interface/inventory-category/modalCreateView'
import { StatusEnum } from '@/enum/status.enum.js'
import {
  InventoryTypeEnum,
  InventoryLockLevel,
} from '@/enum/inventory-category.enum.js'
import InventoryCategoryDetailEditor from '@/components/inventory-category/editor'

export default {
  components: {
    PageHeader,
    'vue-drag-tree': VueDragTree,
    'modal-create-view': modalCreateView,
    InventoryCategoryDetailEditor,
  },
  data() {
    return {
      mappingHybridCategoryValue: null,
      mappingHybridCategoryItems: [],
      // hybridCategoryItems: [],
      id: '',
      title: 'Inventory Category',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Inventory Category',
          href: '/inventory-categories',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      treeModel: [
        {
          view_id: null,
          view_name: 'Root',
          parent_id: null,
          level: 0,
          sequence: 0,
          status: StatusEnum.ACTIVE,
          items: null,
          isCreateNode: true,
        },
      ],
      modal: {
        createView: false,
        deleteView: false,
        confirm: false,
      },
      input: {
        root: null,
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        product_line: null,
        gp_standard: null,
        type: null,
        status: StatusEnum.ACTIVE,
        is_free: false,
        is_control_product: false,
        mapping_hybrid_categories: [],
        isSelectHybridCategory: false,
      },
      isValidate: {
        display_name_th: false,
        display_name_en: false,
      },
      displayCheckBox: false,
      seletedViewId: '',
      parent_id: null,
      level: 0,
      root: null,
      type: null,
      is_free: false,
      isFreeParent: false,
      isCreateFormRoot: false,
      isEdit: false,
      isShowData: false,
      fieldsDetail: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'code_level_1',
          label: 'รหัส Level 1',
          sortable: true,
        },
        {
          key: 'display_name_level_1.th',
          label: 'ชื่อ Level 1 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_1.en',
          label: 'ชื่อ Level 1 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_2',
          label: 'รหัส Level 2',
          sortable: true,
        },
        {
          key: 'display_name_level_2.th',
          label: 'ชื่อ Level 2 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_2.en',
          label: 'ชื่อ Level 2 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_3',
          label: 'รหัส Level 3',
          sortable: true,
        },
        {
          key: 'display_name_level_3.th',
          label: 'ชื่อ Level 3 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_3.en',
          label: 'ชื่อ Level 3 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_4',
          label: 'รหัส Level 4',
          sortable: true,
        },
        {
          key: 'display_name_level_4.th',
          label: 'ชื่อ Level 4 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_4.en',
          label: 'ชื่อ Level 4 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_5',
          label: 'รหัส Level 5',
          sortable: true,
        },
        {
          key: 'display_name_level_5.th',
          label: 'ชื่อ Level 5 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_5.en',
          label: 'ชื่อ Level 5 (อังกฤษ)',
          sortable: true,
        },
      ],
      fieldsEdit: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'code_level_1',
          label: 'รหัส Level 1',
          sortable: true,
        },
        {
          key: 'display_name_level_1.th',
          label: 'ชื่อ Level 1 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_1.en',
          label: 'ชื่อ Level 1 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_2',
          label: 'รหัส Level 2',
          sortable: true,
        },
        {
          key: 'display_name_level_2.th',
          label: 'ชื่อ Level 2 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_2.en',
          label: 'ชื่อ Level 2 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_3',
          label: 'รหัส Level 3',
          sortable: true,
        },
        {
          key: 'display_name_level_3.th',
          label: 'ชื่อ Level 3 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_3.en',
          label: 'ชื่อ Level 3 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_4',
          label: 'รหัส Level 4',
          sortable: true,
        },
        {
          key: 'display_name_level_4.th',
          label: 'ชื่อ Level 4 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_4.en',
          label: 'ชื่อ Level 4 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_5',
          label: 'รหัส Level 5',
          sortable: true,
        },
        {
          key: 'display_name_level_5.th',
          label: 'ชื่อ Level 5 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_5.en',
          label: 'ชื่อ Level 5 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      perPage: 100,
      firstRowOnPage: 1,
      isClearCategorySelector: false,
      isPayloadChanged: false,
      lockLevel: InventoryLockLevel,
      statusNotCreate: ['Delete'],
      messageAlertConfirm: '',
    }
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
    } else {
      this.id = this.$route.params.id
    }
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode
    }
  },
  async mounted() {
    // await this.getHybridCategory()
    await this.getTreeModel()
    if (this.mode !== 'new') {
      this.isShowData = true
      this.isEdit = this.mode === 'view' ? false : true
      await this.getViewById(this.id)
    }
  },
  computed: {
    isShowEditBtn() {
      return !(
        this.input.status === 'Delete' || this.input.status === 'Pending'
      )
    },
    statusLabel() {
      return this.input !== null && this.input.status !== ''
        ? this.input.status.toLowerCase()
        : ''
    },
    typeLabel() {
      return this.input !== null && this.input.type !== ''
        ? this.input.type.toLowerCase()
        : ''
    },
  },
  methods: {
    async getInventoryProductSku(id) {
      var result = await inventoryCategoryService.getInventoryProductSkuListAsync(
        id
      )
      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (result.data.skus.length === 0) {
          this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
        } else {
          if (countStatusProductDelete === result.data.skus.length) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else if (
            countStatusProductAnother === result.data.skus.length ||
            (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
          ) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else {
            this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
          }
        }
      }
    },
    async onSubmit() {
      if (this.messageAlertConfirm !== '') {
        this.$utils
          .confirmAlertDisplay(this.messageAlertConfirm, '')
          .then(async result => {
            if (result) await this.onSave()
          })
      } else await this.onSave()
    },
    onSave() {
      this.$refs.detailEditor.$refs.addDataForm
        .validate()
        .then(async response => {
          console.log('valid')
          if (this.input.isSelectHybridCategory) {
            this.$utils.notificationAck(
              'warning',
              'กรุณาเพิ่มหรือลบ Hybrid Category ก่อน'
            )
            return
          }

          if (
            this.input.status === 'Delete' &&
            this.input.mapping_hybrid_categories !== null &&
            this.input.mapping_hybrid_categories.length > 0
          ) {
            this.$utils.notificationAck(
              'warning',
              'ไม่สามารถปรับได้ ต้องทำการยกเลิกการ Map Hybrid ก่อน'
            )
            return
          }

          console.log('response', response)
          if (response) {
            this.input.mapping_hybrid_categories = []
            if (this.input.is_control_product) {
              this.mappingHybridCategoryItems.forEach(element => {
                let tempParentItems = []
                if (element.level === 1) {
                  let mapping_hybrid_categories = {
                    hybrid_category_id: element.id,
                    hybrid_parent_id: null,
                    hybrid_code: element.code_level_1,
                    hybrid_level: 1,
                    hybrid_category_display_name: {
                      th: element.display_name.th,
                      en: element.display_name.en,
                    },
                    hybrid_parent_categories: tempParentItems,
                  }
                  this.input.mapping_hybrid_categories.push(
                    mapping_hybrid_categories
                  )
                } else if (element.level === 2) {
                  let tempParentLevel1 = {
                    pim_id: element.id_level_1,
                    parent_id: null,
                    code: element.code_level_1,
                    level: 1,
                    display_name: {
                      th: element.display_name_level_1.th,
                      en: element.display_name_level_1.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel1)
                  let mapping_hybrid_categories = {
                    hybrid_category_id: element.id,
                    hybrid_parent_id: element.id_level_1,
                    hybrid_code: element.code_level_2,
                    hybrid_level: 2,
                    hybrid_category_display_name: {
                      th: element.display_name.th,
                      en: element.display_name.en,
                    },
                    hybrid_parent_categories: tempParentItems,
                  }
                  this.input.mapping_hybrid_categories.push(
                    mapping_hybrid_categories
                  )
                } else if (element.level === 3) {
                  let tempParentLevel1 = {
                    pim_id: element.id_level_1,
                    parent_id: null,
                    code: element.code_level_1,
                    level: 1,
                    display_name: {
                      th: element.display_name_level_1.th,
                      en: element.display_name_level_1.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel1)
                  let tempParentLevel2 = {
                    pim_id: element.id_level_2,
                    parent_id: element.id_level_1,
                    code: element.code_level_2,
                    level: 2,
                    display_name: {
                      th: element.display_name_level_2.th,
                      en: element.display_name_level_2.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel2)
                  let mapping_hybrid_categories = {
                    hybrid_category_id: element.id,
                    hybrid_parent_id: element.id_level_2,
                    hybrid_code: element.code_level_3,
                    hybrid_level: 3,
                    hybrid_category_display_name: {
                      th: element.display_name.th,
                      en: element.display_name.en,
                    },
                    hybrid_parent_categories: tempParentItems,
                  }
                  this.input.mapping_hybrid_categories.push(
                    mapping_hybrid_categories
                  )
                } else if (element.level === 4) {
                  let tempParentLevel1 = {
                    pim_id: element.id_level_1,
                    parent_id: null,
                    code: element.code_level_1,
                    level: 1,
                    display_name: {
                      th: element.display_name_level_1.th,
                      en: element.display_name_level_1.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel1)
                  let tempParentLevel2 = {
                    pim_id: element.id_level_2,
                    parent_id: element.id_level_1,
                    code: element.code_level_2,
                    level: 2,
                    display_name: {
                      th: element.display_name_level_2.th,
                      en: element.display_name_level_2.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel2)
                  let tempParentLevel3 = {
                    pim_id: element.id_level_3,
                    parent_id: element.id_level_2,
                    code: element.code_level_3,
                    level: 3,
                    display_name: {
                      th: element.display_name_level_3.th,
                      en: element.display_name_level_3.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel3)
                  let mapping_hybrid_categories = {
                    hybrid_category_id: element.id,
                    hybrid_parent_id: element.id_level_3,
                    hybrid_code: element.code_level_4,
                    hybrid_level: 4,
                    hybrid_category_display_name: {
                      th: element.display_name.th,
                      en: element.display_name.en,
                    },
                    hybrid_parent_categories: tempParentItems,
                  }
                  this.input.mapping_hybrid_categories.push(
                    mapping_hybrid_categories
                  )
                } else if (element.level === 5) {
                  let tempParentLevel1 = {
                    pim_id: element.id_level_1,
                    parent_id: null,
                    code: element.code_level_1,
                    level: 1,
                    display_name: {
                      th: element.display_name_level_1.th,
                      en: element.display_name_level_1.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel1)
                  let tempParentLevel2 = {
                    pim_id: element.id_level_2,
                    parent_id: element.id_level_1,
                    code: element.code_level_2,
                    level: 2,
                    display_name: {
                      th: element.display_name_level_2.th,
                      en: element.display_name_level_2.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel2)
                  let tempParentLevel3 = {
                    pim_id: element.id_level_3,
                    parent_id: element.id_level_2,
                    code: element.code_level_3,
                    level: 3,
                    display_name: {
                      th: element.display_name_level_3.th,
                      en: element.display_name_level_3.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel3)
                  let tempParentLevel4 = {
                    pim_id: element.id_level_4,
                    parent_id: element.id_level_3,
                    code: element.code_level_4,
                    level: 4,
                    display_name: {
                      th: element.display_name_level_4.th,
                      en: element.display_name_level_4.en,
                    },
                  }
                  tempParentItems.push(tempParentLevel4)
                  let mapping_hybrid_categories = {
                    hybrid_category_id: element.id,
                    hybrid_parent_id: element.id_level_4,
                    hybrid_code: element.code_level_5,
                    hybrid_level: 5,
                    hybrid_category_display_name: {
                      th: element.display_name.th,
                      en: element.display_name.en,
                    },
                    hybrid_parent_categories: tempParentItems,
                  }
                  this.input.mapping_hybrid_categories.push(
                    mapping_hybrid_categories
                  )
                }
              })
            }
            let result = await inventoryCategoryService.updateAllInventoryCategoryApprovalAsync(
              this.input.id,
              this.input
            )
            if (result.status === 201) {
              let approval_document = result.data.approval_documents[0]
              this.$utils.notificationAck(
                'success',
                'เพิ่มข้อมูลสำเร็จ',
                `สร้างเอกสาร Request เลขที่ ${result.data.id} <br> เอกสารขออนุมัติ ${approval_document.rule_id}(${approval_document.rule_name.th}) เลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${approval_document.approval_document_id} </a> สำเร็จ`
              )
            } else if (result.status && result.status === 204) {
              await this.getViewById(this.input.id)
              await this.getTreeModel()
              this.isEdit = false
              this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
            } else if (
              (result.status && result.status !== 500) ||
              (result.response && result.response.status !== 500)
            ) {
              this.$utils.notificationAck('error', result.response.data.message)
            }
          }
        })
    },
    async onCreateNode(model) {
      this.isCreateFormRoot = model.view_name === 'Root' ? true : false
      this.level = !this.isCreateFormRoot ? model.level + 1 : 1
      this.parent_id = model.view_id === '' ? null : model.view_id
      this.is_free = false
      if (this.level !== 1) {
        let params = new URLSearchParams()
        params.append('isRequireParent', false)
        let result = await inventoryCategoryService.getInventoryCategoryDetailAsync(
          this.parent_id,
          params
        )
        if (result.status === 200) {
          this.root =
            this.level === 2
              ? result.data.display_name.th + ' (' + result.data.code + ')'
              : result.data.root +
                ' > ' +
                result.data.display_name.th +
                ' (' +
                result.data.code +
                ')'
          this.type = result.data.type
          this.is_free = result.data.is_free
        }
      }
      this.modal.createView = true
    },
    onDeleteNode(model) {
      this.modal.deleteView = true
      this.seletedViewId = model.view_id
    },
    async getTreeModel() {
      let params = new URLSearchParams()
      let result = await inventoryCategoryService.getInventoryCategoryTreeNodeAsync()
      if (result.status === 200) {
        if (result.data.length) {
          this.treeModel[0].items = result.data
        }
      }
    },
    async getViewById(viewId) {
      let params = new URLSearchParams()
      params.append('isRequireParent', false)
      let result = await inventoryCategoryService.getInventoryCategoryDetailAsync(
        viewId,
        params
      )
      if (result.status === 200) {
        // await this.getHybridCategory()
        let _input = result.data
        _input.gp_standard = _input.gp_standard === 0 ? '0' : _input.gp_standard
        this.mappingHybridCategoryItems = []
        this.mappingHybridCategoryValue = null
        if (_input.mapping_hybrid_categories.length > 0) {
          _input.mapping_hybrid_categories.forEach(element => {
            let tempMappingHybridCategory = {
              id: element.hybrid_category_id,
              display_name: {
                th: element.hybrid_category_display_name.th,
                en: element.hybrid_category_display_name.en,
              },
              level: element.hybrid_level,
              id_level_1: null,
              code_level_1: null,
              display_name_level_1: {
                th: null,
                en: null,
              },
              id_level_2: null,
              code_level_2: null,
              display_name_level_2: {
                th: null,
                en: null,
              },
              id_level_3: null,
              code_level_3: null,
              display_name_level_3: {
                th: null,
                en: null,
              },
              id_level_4: null,
              code_level_4: null,
              display_name_level_4: {
                th: null,
                en: null,
              },
              id_level_5: null,
              code_level_5: null,
              display_name_level_5: {
                th: null,
                en: null,
              },
            }
            if (element.hybrid_level === 1) {
              tempMappingHybridCategory.id_level_1 = element.hybrid_category_id
              tempMappingHybridCategory.code_level_1 = element.hybrid_code
              tempMappingHybridCategory.display_name_level_1.th =
                element.hybrid_category_display_name.th
              tempMappingHybridCategory.display_name_level_1.en =
                element.hybrid_category_display_name.en
            } else if (element.hybrid_level === 2) {
              tempMappingHybridCategory.id_level_1 =
                element.hybrid_parent_categories[0].pim_id
              tempMappingHybridCategory.code_level_1 =
                element.hybrid_parent_categories[0].code
              tempMappingHybridCategory.display_name_level_1.th =
                element.hybrid_parent_categories[0].display_name.th
              tempMappingHybridCategory.display_name_level_1.en =
                element.hybrid_parent_categories[0].display_name.en

              tempMappingHybridCategory.id_level_2 = element.hybrid_category_id
              tempMappingHybridCategory.code_level_2 = element.hybrid_code
              tempMappingHybridCategory.display_name_level_2.th =
                element.hybrid_category_display_name.th
              tempMappingHybridCategory.display_name_level_2.en =
                element.hybrid_category_display_name.en
            } else if (element.hybrid_level === 3) {
              tempMappingHybridCategory.id_level_1 =
                element.hybrid_parent_categories[0].pim_id
              tempMappingHybridCategory.code_level_1 =
                element.hybrid_parent_categories[0].code
              tempMappingHybridCategory.display_name_level_1.th =
                element.hybrid_parent_categories[0].display_name.th
              tempMappingHybridCategory.display_name_level_1.en =
                element.hybrid_parent_categories[0].display_name.en

              tempMappingHybridCategory.id_level_2 =
                element.hybrid_parent_categories[1].pim_id
              tempMappingHybridCategory.code_level_2 =
                element.hybrid_parent_categories[1].code
              tempMappingHybridCategory.display_name_level_2.th =
                element.hybrid_parent_categories[1].display_name.th
              tempMappingHybridCategory.display_name_level_2.en =
                element.hybrid_parent_categories[1].display_name.en

              tempMappingHybridCategory.id_level_3 = element.hybrid_category_id
              tempMappingHybridCategory.code_level_3 = element.hybrid_code
              tempMappingHybridCategory.display_name_level_3.th =
                element.hybrid_category_display_name.th
              tempMappingHybridCategory.display_name_level_3.en =
                element.hybrid_category_display_name.en
            } else if (element.hybrid_level === 4) {
              tempMappingHybridCategory.id_level_1 =
                element.hybrid_parent_categories[0].pim_id
              tempMappingHybridCategory.code_level_1 =
                element.hybrid_parent_categories[0].code
              tempMappingHybridCategory.display_name_level_1.th =
                element.hybrid_parent_categories[0].display_name.th
              tempMappingHybridCategory.display_name_level_1.en =
                element.hybrid_parent_categories[0].display_name.en

              tempMappingHybridCategory.id_level_2 =
                element.hybrid_parent_categories[1].pim_id
              tempMappingHybridCategory.code_level_2 =
                element.hybrid_parent_categories[1].code
              tempMappingHybridCategory.display_name_level_2.th =
                element.hybrid_parent_categories[1].display_name.th
              tempMappingHybridCategory.display_name_level_2.en =
                element.hybrid_parent_categories[1].display_name.en

              tempMappingHybridCategory.id_level_3 =
                element.hybrid_parent_categories[2].pim_id
              tempMappingHybridCategory.code_level_3 =
                element.hybrid_parent_categories[2].code
              tempMappingHybridCategory.display_name_level_3.th =
                element.hybrid_parent_categories[2].display_name.th
              tempMappingHybridCategory.display_name_level_3.en =
                element.hybrid_parent_categories[2].display_name.en

              tempMappingHybridCategory.id_level_4 = element.hybrid_category_id
              tempMappingHybridCategory.code_level_4 = element.hybrid_code
              tempMappingHybridCategory.display_name_level_4.th =
                element.hybrid_category_display_name.th
              tempMappingHybridCategory.display_name_level_4.en =
                element.hybrid_category_display_name.en
            } else if (element.hybrid_level === 5) {
              tempMappingHybridCategory.id_level_1 =
                element.hybrid_parent_categories[0].pim_id
              tempMappingHybridCategory.code_level_1 =
                element.hybrid_parent_categories[0].code
              tempMappingHybridCategory.display_name_level_1.th =
                element.hybrid_parent_categories[0].display_name.th
              tempMappingHybridCategory.display_name_level_1.en =
                element.hybrid_parent_categories[0].display_name.en

              tempMappingHybridCategory.id_level_2 =
                element.hybrid_parent_categories[1].pim_id
              tempMappingHybridCategory.code_level_2 =
                element.hybrid_parent_categories[1].code
              tempMappingHybridCategory.display_name_level_2.th =
                element.hybrid_parent_categories[1].display_name.th
              tempMappingHybridCategory.display_name_level_2.en =
                element.hybrid_parent_categories[1].display_name.en

              tempMappingHybridCategory.id_level_3 =
                element.hybrid_parent_categories[2].pim_id
              tempMappingHybridCategory.code_level_3 =
                element.hybrid_parent_categories[2].code
              tempMappingHybridCategory.display_name_level_3.th =
                element.hybrid_parent_categories[2].display_name.th
              tempMappingHybridCategory.display_name_level_3.en =
                element.hybrid_parent_categories[2].display_name.en

              tempMappingHybridCategory.id_level_4 =
                element.hybrid_parent_categories[3].pim_id
              tempMappingHybridCategory.code_level_4 =
                element.hybrid_parent_categories[3].code
              tempMappingHybridCategory.display_name_level_4.th =
                element.hybrid_parent_categories[3].display_name.th
              tempMappingHybridCategory.display_name_level_4.en =
                element.hybrid_parent_categories[3].display_name.en

              tempMappingHybridCategory.id_level_5 = element.hybrid_category_id
              tempMappingHybridCategory.code_level_5 = element.hybrid_code
              tempMappingHybridCategory.display_name_level_5.th =
                element.hybrid_category_display_name.th
              tempMappingHybridCategory.display_name_level_5.en =
                element.hybrid_category_display_name.en
            }
            this.mappingHybridCategoryItems.push(tempMappingHybridCategory)
          })
        }
        _input.mappingHybridCategoryItems = this.mappingHybridCategoryItems
        this.input = _input
      }
    },
    async createView(data) {
      data.level = this.level
      data.parent_id = this.parent_id
      let result = await inventoryCategoryService.createInventoryCategoryAsync(
        data
      )
      if (result.status === 201) {
        await this.getTreeModel()
        this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 1500)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }

      this.modal.createView = false
    },
    allowDrag(model, component) {
      // if (model.name === "Node 0-1") {
      //   // can't be dragged
      //   return false;
      // }
      // // can be dragged
      // return true;
      return false
    },
    allowDrop(model, component) {
      // if (model.name === "Node 2-2") {
      //   // can't be placed
      //   return false;
      // }
      // // can be placed
      // return true;
      return false
    },
    async curNodeClicked(model, component) {
      if (model.view_id !== null) {
        this.isShowData = true
        this.isEdit = false
        await this.getViewById(model.view_id)
      } else {
        this.isShowData = false
      }
    },
    async onEdit() {
      if (this.input.id !== null) {
        this.mappingHybridCategoryValue = null
        this.isEdit = true
        await this.getInventoryProductSku(this.input.id)
        await this.getViewById(this.input.id)
      }
    },
    async onCancel() {
      if (this.input.id !== null) {
        this.isEdit = false
        await this.getViewById(this.input.id)
      }
    },
    onBack() {
      this.$router.push({
        path: '/inventory-categories',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.getViewById(this.input.id)
            this.isClearCategorySelector = !this.isClearCategorySelector
            this.isValidate = {
              display_name_th: false,
              display_name_en: false,
            }
          }
        })
    },
    // async getHybridCategory() {
    //   let params = new URLSearchParams()
    //   let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync()
    //   if (result.status === 200) {
    //     if (result.data.length) {
    //       this.hybridCategoryItems = result.data
    //     }
    //   }
    // },

    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
    genHybridDisplay(input) {
      var result = `${input.display_name_level_1.th} (${input.code_level_1})`
      if (input.code_level_2)
        result += ` > ${input.display_name_level_2.th} (${input.code_level_2})`
      if (input.code_level_3)
        result += ` > ${input.display_name_level_3.th} (${input.code_level_3})`
      if (input.code_level_4)
        result += ` > ${input.display_name_level_4.th} (${input.code_level_4})`
      if (input.code_level_5)
        result += ` > ${input.display_name_level_5.th} (${input.code_level_5})`
      return result
    },
  },
}
</script>
